import { ROUTES_ADMIN } from '@/router'

export enum TabsPathsEnum {
  'generate-purchase-order' = 'generate-purchase-order',
  'purchase-order' = 'purchase-order',
  'supply-payment-required' = 'supply-payment-required',
  'supplier-transaction' = 'supplier-transaction',
  'shipment-invoice' = 'shipment-invoice',
  'inventory' = 'inventory',
}

export const tabPath = (key: keyof typeof TabsPathsEnum) =>
  (
    ({
      'generate-purchase-order':
        ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.GENERATE_PURCHASE_ORDER.path,
      'purchase-order':
        ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.PURCHASE_ORDER.path,
      'supply-payment-required':
        ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.SUPPLY_ORDER_PAYMENT_REQUIRED.path,
      'supplier-transaction':
        ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.SUPPLIER_TRANSACTION.path,
      'shipment-invoice':
        ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.SHIPMENT_INVOICE.path,
      inventory: ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.INVENTORY.path,
    }) as Record<TabsPathsEnum, string>
  )?.[key] || ''

export const getActualTab = (path: string) => {
  return {
    [`/${ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.GENERATE_PURCHASE_ORDER.path}`]:
      'generate-purchase-order',
    [`/${ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.PURCHASE_ORDER.path}`]:
      'purchase-order',
    [`/${ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.SUPPLY_ORDER_PAYMENT_REQUIRED.path}`]:
      'supply-payment-required',
    [`/${ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.SUPPLIER_TRANSACTION.path}`]:
      'supplier-transaction',
    [`/${ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.SHIPMENT_INVOICE.path}`]:
      'shipment-invoice',
    [`/${ROUTES_ADMIN.SUPPLY.ORDER_MANAGEMENT.INVENTORY.path}`]: 'inventory',
  }[`${path}`]
}
